import { LynxTable } from "components/LynxTable/LynxTable";
import { dateEndFormatting, dateStartFormatting } from "helpers/dateFormatting";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "store/StoreConfigs";
import { useParams } from "react-router-dom";
import { routeViewShipmentsTableColumns } from "./RouteViewShipmentsTableColumns";
import { RouteShipmentsRequestModel } from "api/lokiRequestModels/shipments/RouteShipmentsRequestModel";

export const RouteViewShipmentsTableWrapper = observer(function TableWrapper() {
    const { routeViewStore, filtersStore, identityStore } = useStore();
    const { routeId } = useParams<any>();

    const onSortChange = (id: string, sortDirection: "ASC" | "DESC") => {
        routeViewStore.setShipmentSortProperty(id);
        routeViewStore.setShipmentDirection(sortDirection);
    };

    const onPageChange = (direction: "back" | "forward") => {
        if (direction === "back") {
            routeViewStore.moveToPreviousShipmentsPage();
        } else {
            const request: RouteShipmentsRequestModel = {
                startTime: dateStartFormatting(filtersStore.startDate),
                endTime: dateEndFormatting(filtersStore.endDate),
                routeId,
                customerId: identityStore.currentCustomerId,
                lsp: filtersStore.selectedLogisticsServiceProviders.join(",") || undefined,
                productType: filtersStore.selectedProductTypes.join(",") || undefined,
                riskLevel: filtersStore.selectRiskLevels.join(",") || undefined,
                transportationModes: filtersStore.selectedModesOfTransportation.join(",") || undefined,
                packagingType: filtersStore.selectedPackagingTypes.join(",") || undefined,
                nextToken: routeViewStore.shipmentNextToken,
                sort: routeViewStore.sortShipment,
                direction: routeViewStore.directionShipment,
            };

            routeViewStore.moveToNextShipmentPage(request);
        }
    };

    return (
        <LynxTable
            columns={routeViewShipmentsTableColumns}
            rows={
                routeViewStore.shipmentPages.length === 0
                    ? []
                    : routeViewStore.shipmentPages[routeViewStore.currentShipmentPage - 1]
            }
            rowKey="shipmentId"
            expandableContent={() => "Expandable content"}
            page={routeViewStore.currentShipmentPage}
            isLastPage={routeViewStore.isLastShipmentPage}
            onPageChange={onPageChange}
            sortedBy={routeViewStore.sortShipment}
            sortDirection={routeViewStore.directionShipment}
            onSortChange={onSortChange}
            isLoading={routeViewStore.loadingShipments}
        />
    );
});
